<app-layout class="container--md">
  <div class="inner-container">
    <div class="row row-title">
      <p class="heading-h5-regular">My Documents</p>
    </div>
    <mat-tab-group (selectedIndexChange)="onSelectedIndexChange($event)" #formTabs dynamicHeight
      mat-stretch-tabs="false" mat-align-tabs="start">
      <mat-tab *ngFor="let tab of docTabs; let i = index">
        <ng-template mat-tab-label>
          {{ tab.label }} ({{ tab.badge }})
        </ng-template>
        <!-- Tab Content -->
        <div class="app-documents">
          <app-my-documents-listing *ngIf="isDataLoaded" [docStatus]="tab.label" [index]="i"
            [selectedIndex]="selectedIndex" [initialData]="tab.data"
            [badgeCount]="tab.badge"></app-my-documents-listing>
          <div *ngIf="!isDataLoaded"><mat-spinner class="mydocs-spinner"></mat-spinner>
            <div class="mydocs-spinner-text">
              <p>Retrieving data...</p>
            </div>
          </div>
        </div>
      </mat-tab>
      <!-- <mat-tab label="All">
        <div class="app-documents">
          <app-my-documents-listing [docStatus]="'All'" [index]="0"
            [selectedIndex]="selectedIndex"></app-my-documents-listing>
        </div>
      </mat-tab>
      <mat-tab label="Draft">
        <div class="app-documents">
          <app-my-documents-listing [docStatus]="'Draft'" [index]="1"
            [selectedIndex]="selectedIndex"></app-my-documents-listing>
        </div>
      </mat-tab>
      <mat-tab label="Pending">
        <div class="app-documents">
          <app-my-documents-listing [docStatus]="'Pending'" [index]="2"
            [selectedIndex]="selectedIndex"></app-my-documents-listing>
        </div>
      </mat-tab>
      <mat-tab label="Completed">
        <div class="app-documents">
          <app-my-documents-listing [index]="3" [selectedIndex]="selectedIndex"
            [docStatus]="'Completed'"></app-my-documents-listing>
        </div>
      </mat-tab> -->
    </mat-tab-group>
  </div>
</app-layout>